import { render, staticRenderFns } from "./AddAccommodation.vue?vue&type=template&id=515047cf&"
import script from "./AddAccommodation.vue?vue&type=script&lang=js&"
export * from "./AddAccommodation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports